import * as React from 'react';
import { antGrey, appHomeCardsWidgetTitleStyle, runwayColors } from '@/components/styles/globalStyles';
import Text from 'antd/lib/typography/Text';
import MarkdownParagraphWithEllipsis from '../../HOCs/MarkdownParagraphWithEllipsis';

export interface ReleaseDescriptionWidgetProps {
    description?: string;
}

export const ReleaseDescriptionWidget: React.FC<ReleaseDescriptionWidgetProps> = ({ description }) => {
    return (
        <div
            style={{
                borderColor: antGrey.grey5,
                borderWidth: 1,
                borderStyle: 'solid',
                padding: '12px 20px',
                display: 'flex',
                flexDirection: 'column',
                gap: 8,
                borderRadius: 8,
                marginBottom: 28,
            }}
        >
            <Text style={{ ...appHomeCardsWidgetTitleStyle }}>Release description</Text>
            {description && description.length > 0 ?
                <MarkdownParagraphWithEllipsis
                    content={description}
                    maxHeight="250px"
                    style={{
                        fontSize: 14,
                    }}
                    backgroundColor={runwayColors.white}
                />
            :   <Text
                    style={{
                        fontSize: 14,
                        color: antGrey.grey6,
                    }}
                >
                    No notes added
                </Text>
            }
        </div>
    );
};
